import React, { Component } from 'react'
import { postFetchWrapper } from '../../../utils/fetchHelpers'
import buildUrl from '../../../utils/apiHelpers'
import TableCell from '../../Table/TableCell'

class UrlTableRow extends Component {
  constructor (props) {
    super(props)

    this.state = {
      cancelledSuccessfully: false
    }

    this.handleCancelLink = this.handleCancelLink.bind(this)
  }

  handleCancelLink () {
    this.setState({ isUpdating: true })
    postFetchWrapper(buildUrl('/api/v1/cancel_url'), { id: this.props.submittedUrl.id })
      .then((response) => response.json())
      .then((data) => {
        console.log('url cancelled', data)
        this.setState({ cancelledSuccessfully: true })
      })
      .catch((error) => {
        console.log('url not cancelled', error)
        this.setState({ cancelledSuccessfully: false })
        // how to handle this in terms of UI?
      })
  }

  render () {
    const { url, submittedAt, rejectionReason } = this.props.submittedUrl
    const status = this.state.cancelledSuccessfully ? 'Cancelled' : this.props.submittedUrl.status
    const formattedSubmittedAt = submittedAt ? new Date(submittedAt).toLocaleDateString() : 'N/A'
    const showCancelCta = status === 'Listing under creation'
    const RejectionReason = status === 'Rejected' && rejectionReason ? rejectionReason : 'N/A'

    return (
      <tr className='grid p-16 gap-x-16 grid-rows-[minmax(80px,max-content)] border-b border-midnight-black-20 hover:bg-[#FBFCFC]' style={{ gridTemplateColumns: this.props.gridTemplateColumns }}>
        <TableCell content={url} />
        <TableCell content={formattedSubmittedAt} />
        <TableCell content={status} type='status' />
        <TableCell content={RejectionReason} />
        <TableCell
          content={showCancelCta ? 'cancel' : 'N/A'}
          type={showCancelCta ? 'cancel' : null}
          onCancelLinkClick={this.handleCancelLink}
        />
      </tr>
    )
  }
}

export default UrlTableRow
